module.exports = __webpack_public_path__ + "static/img/4.cf25119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/cpxh/4.jpg
// module id = J4VS
// module chunks = 0